<template>
    <transition mode="out-in" name="leftIn">
        <router-view></router-view>
    </transition>
</template>

<script>
import api from '@/mixins/api.js'
import router from '@/router/index.js'

export default {
    mixins: [api],

    created() {
        this.get_config();
        this.verify_auth();
        this.get_config_view_menu();
        this.subscribe_pusher();
    },

    methods: {
        async get_config() {
            const response = await this.GET("Config");

            if (response.status == 'success') {
                this.$store.dispatch("update_config", response.result);
            }
        },

        async verify_auth() {
            const response = await this.POST("Auth/Verify", { api_token: localStorage.token });

            if (response.status == "success") {
                this.$store.dispatch("update_user", response.result);
            } else {
                localStorage.removeItem('auth')
                localStorage.removeItem('token')
                if (window.location.href.indexOf('App') > 0)

                    router.push('/Login');
            }
        },

        async get_config_view_menu() {
            const response = await this.GET("ConfigViewMenu");

            if (response.status == 'success') {
                this.$store.dispatch("update_config_view_menu", response.result);
            }
        },

        subscribe_pusher() {
            // console.log(this.$pusher)

            // this.$pusher.subscribe('peers', channel => {
            //     channel.bind('App\\Events\\StatusPeersEvent', () => {
            //         console.log("Oi");
            //     })
            // })
        }
    }
}
</script>

<style>
.leftIn-enter,
.leftIn-leave-to {
    transform: translate3d(-40px, 0, 0);
    opacity: 0
}

.topIn-enter,
.topIn-leave-to {
    transform: translate3d(0, -40px, 0);
    opacity: 0
}

.leftIn-enter-active,
.leftIn-leave-active,
.topIn-enter,
.topIn-leave-to {
    transition: all 0.3s;
}</style>
